import React, { Component } from 'react'
import { connect } from 'react-redux'
import { getResource } from '../redux/actionCreators/resources'
import Rows from './bootstrap/Rows'
import Inflection from 'inflection'

class Sensor extends Component {
  constructor(props) {
    super(props)
    this.state = {
      activeTabName: null,
      activeTab: null
    }
  }
  
  componentDidMount() {
    if (this.props.canMakeSensorRequest) this.props.getSensor()
      
    if (this.props.sensorCustomPropsLoaded && this.state.activeTab === null) {
      this.showCustomPropertiesTab()
    }
  }
  
  componentDidUpdate() {
    if (this.props.canMakeSensorRequest && !this.props.sensorLoaded) this.props.getSensor()
    
    if (this.props.sensorCustomPropsLoaded && this.state.activeTab === null) {
      this.showCustomPropertiesTab()
    }
  }
  
  showCustomPropertiesTab() {
    if (!this.props.sensorCustomPropsLoaded) return
    let custom_properties = Object.keys(this.props.sensor.custom_properties).map((key, index) => {
      let value = this.props.sensor.custom_properties[key]
      if (typeof value !== "string") value = JSON.stringify(value)
      return [
        {value: Inflection.titleize(key), className: "col-3 font-weight-bold"},
        {value}
      ]
    });
    
    this.setState({
      activeTabName: "custom_properties",
      activeTab: (
        <div className="card-body">
          <Rows rows={custom_properties} />
        </div>
      )
    })
  }
  
  render() {
    if (!this.props.sensorLoaded) return (
      <div />
    )
    
    return (
      <div className="px-5 pt-3">
        <div className="card">
          <div className="card-header">
            {this.props.sensor.name}
          </div>
          <div className="card-body">
            <Rows rows={[
              [{value: "DevEUI", className: "col-2 font-weight-bold"}, {value: this.props.sensor.dev_eui}],
              [{value: "Name", className: "col-2 font-weight-bold"}, {value: this.props.sensor.name}],
              [{value: "Sensor Type Id", className: "col-2 font-weight-bold"}, {value: this.props.sensor.sensor_type_id}],
              [{value: "Asset Id", className: "col-2 font-weight-bold"}, {value: this.props.sensor.asset_id}],
              [{value: "Network Server Id", className: "col-2 font-weight-bold"}, {value: this.props.sensor.network_server_id}],
              [{value: "AppEUI", className: "col-2 font-weight-bold"}, {value: this.props.sensor.app_eui}],
              [{value: "AppKey", className: "col-2 font-weight-bold"}, {value: this.props.sensor.app_key}],
              [{value: "Activation Method", className: "col-2 font-weight-bold"}, {value: this.props.sensor.activation_method}],
              [{value: "Status", className: "col-2 font-weight-bold"}, {value: this.props.sensor.status}],
              [{value: "Last Payload", className: "col-2 font-weight-bold"}, {value: this.props.sensor.last_payload}],
              [{value: "Last Updated", className: "col-2 font-weight-bold"}, {value: this.props.sensor.last_updated}]
            ]} />
            
            <div className="card mt-3">
              <div className="card-header">
                <ul className="nav nav-tabs card-header-tabs">
                  <li className="nav-item">
                    <span className={ this.state.activeTabName === "custom_properties" ? "nav-link active" : "nav-link" } onClick={() => {this.showCustomPropertiesTab()}} >Custom Properties</span>
                  </li>
                </ul>
              </div>
              {this.state.activeTab}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  sensorLoaded: function() {
    let sensorList = state.api.sensors || {}
    let sensor = sensorList[ownProps.match.params.devEUI] || {}
    return sensor.isLoaded || false
  }(),
  canMakeSensorRequest: function() {
    let sensorList = state.api.sensors || {}
    let sensor = sensorList[ownProps.match.params.devEUI] || {}
    return state.oidc.user && !state.oidc.user.expired && !(sensor.isLoading || false) && !(sensor.isError || false)
  }(),
  sensor: function() {
    let sensorList = state.api.sensors || {}
    return sensorList[ownProps.match.params.devEUI] || {}
  }(),
  sensorCustomPropsLoaded: function() {
    let sensorList = state.api.sensors || {}
    let sensor = sensorList[ownProps.match.params.devEUI] || {}
    return sensor.custom_properties !== undefined
  }()
})

const mapDispatchToProps = (dispatch, ownProps) => ({
  getSensor: () => {dispatch(getResource("sensors", ownProps.match.params.devEUI))}
})

export default connect(
  mapStateToProps,
  mapDispatchToProps 
)(Sensor)